exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-platform-category[data-v-16d79cbe]{width:100%}.ppc-view-value[data-v-16d79cbe]{color:#17233d}.ppc-form[data-v-16d79cbe]{width:100%}.form-item-flex-wrap[data-v-16d79cbe]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around}.form-item-flex-wrap .ppc-view-item[data-v-16d79cbe]{min-width:300px;line-height:32px;font-size:14px}.form-item-flex-wrap .ppc-view-label[data-v-16d79cbe]{color:#515a6e;font-weight:500}.form-item-flex-wrap .ivu-form-item[data-v-16d79cbe]{margin-bottom:0}", ""]);

// exports
